module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic10.19f32f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic10.png
// module id = 577
// module chunks = 1